// src/actions/questionnaireActions.js
import api from '../api/axios';
import {
    QUESTIONNAIRE_CURRENT_REQUEST,
    QUESTIONNAIRE_CURRENT_SUCCESS,
    QUESTIONNAIRE_CURRENT_FAIL,
    QUESTIONNAIRE_SAVE_ANSWER_REQUEST,
    QUESTIONNAIRE_SAVE_ANSWER_SUCCESS,
    QUESTIONNAIRE_SAVE_ANSWER_FAIL,
    QUESTIONNAIRE_COMPLETE_REQUEST,
    QUESTIONNAIRE_COMPLETE_SUCCESS,
    QUESTIONNAIRE_COMPLETE_FAIL,
    QUESTIONNAIRE_CHECK_ACCESS_REQUEST,
    QUESTIONNAIRE_CHECK_ACCESS_SUCCESS,
    QUESTIONNAIRE_CHECK_ACCESS_FAIL,
} from '../constants/questionnaireConstants';

export const getCurrentQuestionnaire = () => async (dispatch) => {
    try {
        dispatch({ type: QUESTIONNAIRE_CURRENT_REQUEST });

        const { data } = await api.get('/questionnaire/current/');

        dispatch({
            type: QUESTIONNAIRE_CURRENT_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: QUESTIONNAIRE_CURRENT_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const saveAnswer = (questionKey, answerValue) => async (dispatch) => {
    try {
        dispatch({ type: QUESTIONNAIRE_SAVE_ANSWER_REQUEST });

        const { data } = await api.post('/questionnaire/save-answer/', {
            question_key: questionKey,
            answer_value: answerValue
        });

        dispatch({
            type: QUESTIONNAIRE_SAVE_ANSWER_SUCCESS,
            payload: data,
        });

        // Odśwież aktualny kwestionariusz
        dispatch(getCurrentQuestionnaire());
    } catch (error) {
        dispatch({
            type: QUESTIONNAIRE_SAVE_ANSWER_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.message,
        });
    }
};

export const completeQuestionnaire = () => async (dispatch) => {
    try {
        dispatch({ type: QUESTIONNAIRE_COMPLETE_REQUEST });

        const { data } = await api.post('/questionnaire/complete/', {});

        dispatch({
            type: QUESTIONNAIRE_COMPLETE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: QUESTIONNAIRE_COMPLETE_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.message,
        });
    }
};

export const checkVacationAccess = () => async (dispatch) => {
    try {
        dispatch({ type: QUESTIONNAIRE_CHECK_ACCESS_REQUEST });

        const { data } = await api.get('/questionnaire/check-access/');

        dispatch({
            type: QUESTIONNAIRE_CHECK_ACCESS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: QUESTIONNAIRE_CHECK_ACCESS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};